import { Button, Card, Col, Input, Row, Spin, Table, Tooltip } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { useClient } from "../../../Context/ClientContext";
import { ColumnsType } from "antd/es/table";
import {
  DeleteOutlined,
  EditOutlined,
  LoadingOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { notificationContext } from "../../../Common/Routing/PageRoute";
import { ConfirmationModal } from "../../../Common/ConfirmationModal";
import { useTheme } from "../../../Context/ThemeContext";
import AssetLocationService, {
  IFALocationList,
} from "../../../Services/AssetLocationService";
import AddAssetLocationModal from "./AddAssetLocationModal";

const AssetLocation = () => {
  const { currentClient } = useClient();
  const { themeData } = useTheme();
  const { openNotification } = useContext(notificationContext);
  const [isModelOpen, setIsModelOpen] = useState<boolean>(false);
  // const [addAssLocation, setAddAssLocation] = useState<IFALocation>({
  //   locationName: "",
  // });

  const [locationDataList, setLocationDataList] = useState<IFALocationList[]>(
    []
  );
  // const [updateLocationData, setUpdateLocationData] = useState<IFALocation>({
  //   locationName: "",
  // });
  const [pageSize, setPageSize] = useState<number>(
    themeData?.tablePageSize ?? 15
  );
  const [page, setPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [id, setId] = useState<any>({ id: "", name: "" });
  const [confirmation, setConfirmation] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [refresh, setRefresh] = useState<boolean>(false);
  const [search, setSearch] = useState<string>("");

  // To update the asset locations list with amended new asset location
  // useEffect(() => {
  //   if (addAssLocation.id) {
  //     setLocationDataList((prev) =>
  //       updateListWithNewValue(prev, addAssLocation, true).sort((a, b) =>
  //         a.locationName.localeCompare(b.locationName)
  //       )
  //     );
  //   }
  // }, [addAssLocation]);

  // To get asset locations list
  const getLocationList = async () => {
    setLoading(true);
    await AssetLocationService.getLocationList(
      currentClient?.id!,
      (page - 1) * pageSize,
      pageSize,
      search
    ).then((res) => {
      if (res?.status) {
        setLocationDataList(
          res?.result?.map((d: IFALocationList, index: number) => ({
            locationName: d?.locationName,
            sno: index + 1,
            id: d?.id,
            subUnitId: d?.subUnitId,
            subUnitName: d?.subUnitName,
          }))
        );
        setLoading(false);
        // setTotalRecords(res?.result?.length);
      } else {
        setLoading(false);
      }
    });
  };
  useEffect(() => {
    getLocationList();
  }, [
    // (page - 1) * pageSize,
    // pageSize,
    refresh,
    search,
  ]);

  // To delete asset location
  const deleteLocationData = async () => {
    let res = await AssetLocationService?.deleteLocationDatabyId(
      currentClient?.id,
      id?.id
    );
    if (res?.status) {
      setRefresh((prev) => !prev);
      openNotification("success", "Asset location deleted successfully.");
      setConfirmation(false);
    } else {
      openNotification("error", res?.message);
      setConfirmation(false);
    }
  };

  const columns: ColumnsType<IFALocationList> = [
    {
      title: "S.No.",
      dataIndex: "sno",
      width: "10%",
      render: (val, _, index) => index + 1,
    },
    { title: "Location Name", dataIndex: "locationName" },
    { title: "Sub Unit Name", dataIndex: "subUnitName" },
    {
      title: "Action",
      dataIndex: "",
      render: (_, record) => (
        <>
          <Row gutter={10}>
            <Col>
              <Tooltip title="Edit">
                {/* <FormOutlined
                  onClick={() => {
                    setId({ id: record?.id, name: record?.locationName });
                    setIsModelOpen(true);
                  }}
                /> */}
                <EditOutlined
                  onClick={() => {
                    setId({ id: record?.id, name: record?.locationName });
                    setIsModelOpen(true);
                  }}
                />
              </Tooltip>
            </Col>
            <Col>
              <Tooltip title="Delete" color="red">
                <DeleteOutlined
                  style={{ color: "red" }}
                  onClick={() => {
                    setId({ id: record?.id, name: record?.locationName });
                    setConfirmation(true);
                  }}
                />
              </Tooltip>
            </Col>
          </Row>
        </>
      ),
    },
  ];

  return (
    <>
      <div>
        <Card
          size="small"
          className="TableCard"
          style={{
            marginTop: 35,
            boxShadow: "0px 0px 10px 0px #96A1C84D",
          }}
        >
          <div style={{ padding: "0px 0px 3px 0px" }}>
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: 20 }} />}
              spinning={loading}
            >
              <Row justify={"space-between"}>
                <Col>
                  <Button
                    icon={<PlusOutlined />}
                    type="primary"
                    onClick={() => {
                      setIsModelOpen(true);
                      setId("");
                    }}
                  >
                    Add Location
                  </Button>
                </Col>
                <Col>
                  <Input
                    placeholder="Search..."
                    allowClear
                    onClear={() => setSearch("")}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        setSearch(e.currentTarget.value);
                      } else {
                        return e;
                      }
                    }}
                  />
                </Col>
              </Row>
              <div style={{ marginTop: "4px" }}>
                <Table
                  className={`Tabel-style table-${
                    themeData?.componentSize ?? "middle"
                  }`}
                  columns={columns}
                  dataSource={locationDataList}
                  pagination={false}
                  // pagination={{
                  //   total: totalRecords,
                  //   current: page,
                  //   pageSize: pageSize,
                  //   showSizeChanger: true,
                  //   onChange: (page: number, pageSize: number) => {
                  //     setPage(page);
                  //     setPageSize(pageSize);
                  //   },
                  //   pageSizeOptions: tablePageSizeOptions,
                  // }}
                  // scroll={
                  //   pageSize > 15
                  //     ? { x: 1500, y: window.innerHeight - 300 }
                  //     : undefined
                  // }
                />
              </div>
            </Spin>
          </div>
        </Card>
      </div>

      {isModelOpen && (
        <AddAssetLocationModal
          onCancel={() => setIsModelOpen(false)}
          isModelOpen={isModelOpen}
          id={id?.id}
          // setAddAssLocation={setAddAssLocation}
          setRefresh={setRefresh}
        />
      )}

      {confirmation && (
        <ConfirmationModal
          open={confirmation}
          onNo={() => setConfirmation(false)}
          onYes={() => {
            deleteLocationData();
          }}
          text={`Are you sure you want to delete "${id?.name}"? `}
        />
      )}
    </>
  );
};

export default AssetLocation;
